export default __webpack_public_path__ + "static/media/messages_1.8af1dc24.png";